<template>
  <div v-if="isOpen" class="mf-modal">
    <div class="mf-modal__shadow" @click="onClose()"></div>
    <div class="mf-modal__content">
      <div class="mf-modal__header">
        <span>{{translate('offDealsFilters')}}</span>
        <button class="btn btn-close-more-filters" @click="onClose()">
          <i class="icon-cross xs" />
        </button>
      </div>
      <div class="mf-modal__body">
        <div class="points">
          <img class="points__logo" :src="radissonRewardsUrl" alt="Radisson Rewards" />
          <div class="points__text">
            <div class="points__title">{{translate('offDealsSliderFiltersHeading')}}</div>
            <div class="points__subtitle">
              {{translate('offDealsSliderFiltersSubeading')}}
            </div>
          </div>
          <div class="points__toggle">
            <label class="btn-switch btn-switch--toggle">
              <input type="checkbox" :checked="clonedPoints" @change="togglePoints()" />
              <span class="slider slider__lg"></span>
            </label>
          </div>
        </div>

        <div class="points-mobile">
          <img class="points-mobile__logo" :src="radissonRewardsUrl" alt="Radisson Rewards" />
          <div class="points-mobile__toggle">
            <label class="btn-switch btn-switch--toggle">
              <input
                class="only-points"
                type="checkbox"
                :checked="clonedPoints"
                @change="togglePoints()"
              />
              <span class="slider slider__lg"></span>
            </label>
            <div class="points-mobile__title">{{translate('offDealsSliderFiltersHeading')}}</div>
          </div>
          <div class="points-mobile__subtitle">
            {{translate('offDealsSliderFiltersSubeading')}}
          </div>
        </div>

        <div class="brand-filter">
          <div class="brand-filter__title">{{translate('offDealsHotelBrands')}}</div>
          <div class="brand-filter__brands">
            <div
              class="transition-all brand"
              :class="brand.selected && 'brand--selected'"
              v-for="brand in sortedBrands"
              :key="brand.code"
              @click="toggleBrands(brand)"
              role="button"
            >
              <img
                crossorigin="anonymous"
                class="brand__icon"
                :src="`${brandLogosUrl}/${brand.code}.svg`"
                :alt="brand.name"
              />
              <span class="brand__title">{{ brand.name }}</span>
              <i
                class="transition-all icon-check xs"
                :class="brand.selected ? 'brand__selection' : 'brand__unselection'"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="mf-modal__footer">
        <ClearAllFiltersBtn
          v-if="isMobile"
          data-testid="button-clear-filters-mobile-modal"
          :mobile="isMobile"
          :modal="true"
          @click="clearModalFilters"
        />
        <button v-else class="cancel-filters" @click="onClose()">{{translate('offDealsCancel')}}</button>
        <button class="apply-filters" @click="onApplyFilters()">{{translate('offDealsApplyFilters')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { assetsUrl } from '@/infrastructure/Configuration'
import ClearAllFiltersBtn from '@/components/filters/ClearAllFiltersBtn'

export default {
  name: 'MoreFilter',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    brands: {
      type: Array,
      required: true
    },
    points: {
      type: Boolean,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  components: {
    ClearAllFiltersBtn
  },
  data: () => ({
    brandLogosUrl: `${assetsUrl}/img/logos/rounded`,
    radissonRewardsUrl: `${assetsUrl}/svg/radisson-rewardsnewicon.svg`,
    clonedBrands: [],
    clonedPoints: false
  }),
  watch: {
    isOpen() {
      const bodyEl = document.querySelector('body')
      this.isOpen
        ? bodyEl.classList.add('overflow-hidden')
        : bodyEl.classList.remove('overflow-hidden')
    },
    brands(newValue) {
      this.clonedBrands = newValue
    },
    points(newValue) {
      this.clonedPoints = newValue
    }
  },
  created() {
    this.clonedBrands = this.brands
    this.clonedPoints = this.points
  },
  methods: {
    toggleBrands(brand) {
      if (this.clonedBrands.filter(b => b.code === brand.code && b.selected).length > 0) {
        this.clearModalFilters()
      } else {
        this.clonedBrands = [
          ...this.clonedBrands.map(b => ({ ...b, selected: b.code === brand.code }))
        ]
      }
    },
    clearModalFilters() {
      this.clonedBrands = [...this.clonedBrands.map(b => ({ ...b, selected: false }))]
      this.clonedPoints = false
    },
    togglePoints() {
      this.clonedPoints = !this.clonedPoints
    },
    onApplyFilters() {
      this.$emit('filter-change', {
        brands: this.clonedBrands.filter(b => b.selected),
        points: this.clonedPoints
      })
      this.$emit('close')
    },
    onClose() {
      this.clonedBrands = this.brands
      this.clonedPoints = this.points
      this.$emit('close')
    }
  },
  computed: {
    sortedBrands() {
      const excludedBrandCode = 'ry'
      const order = {
        rdr: 4,
        pii: 7,
        rdb: 2,
        art: 10,
        rad: 3,
        ri: 5,
        prz: 9,
        pph: 6,
        cis: 8,
        rco: 1
      }

      return (this.clonedBrands || [])
        .filter(brand => brand.code !== excludedBrandCode)
        .map(it => ({ ...it, order: order[it.code] }))
        .sort((a, b) => a.order - b.order)
    }
  }
}
</script>

<style scoped lang="scss">
.mf-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 103vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: zindex('cover-all');

  &__shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: color('black');
    opacity: 0.8;
  }

  &__content {
    position: relative;
  }

  &__header {
    font-size: 1.8rem;
    font-weight: 300;
    color: color('white');
    padding: 1rem 0;
    display: flex;
    justify-content: space-between;
  }

  &__body {
    display: flex;
    flex-direction: column;
    padding: 6.5rem 3.5rem 3.5rem 3.5rem;
    background: color('white');
    row-gap: 3rem;
    border-radius: 4px;
  }

  &__footer {
    border-top: solid 1px color('alto');
    padding: 3rem;
    background: color('white');
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: 576px) {
    &__shadow {
      display: none;
    }

    &__content {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &__header {
      font-size: 2rem;
      color: color('black');
      padding: 3rem;
      display: flex;
      justify-content: space-between;
      background: color('white');
      border-bottom: solid 1px color('alto');
    }
    &__body {
      padding: 3rem;
      background: color('white');
      flex-grow: 1;
      overflow-y: scroll;
      margin-bottom: 10rem;
    }
    &__body::-webkit-scrollbar {
      display: none;
    }
    &__footer {
      border-top: solid 1px color('alto');
      padding: 2rem;
      background: color('white');
      position: fixed;
      width: 100%;
      bottom: 0;
    }

    @media (max-width: 576px) {
      padding: 0;

      &__footer {
        border-top: solid 1px color('white');
        background: color('white');
      }
    }
  }
}

.points {
  width: 100%;
  display: flex;
  flex-direction: row;
  border: solid 1px color('alto');
  padding: 3.5rem;
  border-radius: 2rem;
  column-gap: 3rem;

  &__logo {
    width: 25%;
  }

  &__text {
    display: flex;
    flex-direction: column;
    row-gap: 1.5rem;
  }

  &__title {
    font-size: 2rem;
  }

  &__subtitle {
    font-size: 1.5rem;
  }

  &__toggle {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.points-mobile {
  display: none;
  width: 100%;
  flex-direction: column;
  border: solid 1px color('alto');
  padding: 3rem 2rem;
  border-radius: 2rem;
  row-gap: 2.5rem;

  &__logo {
    width: 40%;
  }

  &__toggle {
    display: flex;
    align-items: center;
    padding-left: 1.5rem;
    column-gap: 2.5rem;
  }

  &__title {
    font-size: 1.5rem;
  }

  &__subtitle {
    font-size: 1.5rem;
  }
}

@media (max-width: 576px) {
  .points {
    display: none;
  }
  .points-mobile {
    display: flex;
  }
}

.brand-filter {
  display: flex;
  flex-direction: column;

  &__title {
    font-size: 2rem;
  }

  &__brands {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.5rem;
    padding: 3rem;

    @media (max-width: 576px) {
      padding: 3rem 0;
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
}

.brand {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0.2rem 1.2rem 0.2rem 0.2rem;
  background: color('white');
  border: solid 1px color('alto');
  border-radius: 10rem;
  cursor: pointer;
  height: 4rem;
  column-gap: 1rem;

  &--selected {
    border: solid 1px color('black');
  }

  &__icon {
    height: 100%;
  }

  &__title {
    white-space: nowrap;
    flex-grow: 1;
  }

  &__selection {
    color: color('primary');
  }

  &__unselection {
    color: color('white');
  }
}

.slider {
  &__lg {
    transform: scale(1.8);
  }
}

.btn-close-more-filters {
  padding: 0;

  i {
    margin: 0;
    color: color('white');
    @media (max-width: 576px) {
      color: color('black');
    }
  }
}

.cancel-filters {
  text-transform: capitalize;
  background: transparent;
  color: color('black');
  padding: 1rem;
  border: 0 solid;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.apply-filters {
  text-transform: uppercase;
  background: color('primary');
  color: color('white');
  padding: 1.5rem 5rem;
  border-radius: 10rem;
  border: 0 solid;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
</style>
